<template>
  <!-- <div class="tableHome" v-bind:style="{ 'background-image': 'url(' + this.tournImage + ')' }"> -->
  <div>
    <template v-if="showcptreports == 'Y' && cptshowTourn == true || showcp2reports == 'Y' && cp2showTourn == true || showcp3reports == 'Y' && cp3showTourn == true || showpamreports == 'Y' && pamshowTourn == true || showporreports == 'Y' && qscshowTourn == true || showqscreports == 'Y' && qscshowTourn == true">
      <div class="above990">
        <vueper-slides autoplay :arrows="false" :pauseOnHover="true" :duration="6000" :infinite="false" :touchable="false">
          <vueper-slide v-for="x in shuffledItems.slice(0,1)" :key="x">
              <template #content>
                <div class="tableHome" v-bind:style="{ 'background-image': 'url(' + x.desktop_image + ')' }">
                  <!-- <img class="active tableHome firstClass" :src="x.desktop_image"> -->
                  <div class="outerDiv">
                      <div class="innerDiv">
                          <h1 class="heading" :style="'color:' + x.slide_heading_color">{{x.slide_heading}}</h1>
                          <p class="line1" v-html="x.slide_text_line_1"></p>
                          <p class="line2" v-html="x.slide_text_line_2"></p>
                          <p class="lin3" v-html="x.slide_text_line_3"></p>
                      </div>
                  </div>
                </div>
              </template>
          </vueper-slide>
          <vueper-slide v-for="i in toursAsone" :key="i">
            <template #content>
              <div class="tours">
                <div class="tableHome" v-bind:style="{ 'background-image': 'url(' + tournImage + ')' }">
                  <b-container>
                    <b-row class="above1200">
                      <b-col>
                        <b-row class="SponsorLogoText">
                          <b-col>
                            <div class="classTournBtn">
                                <button class="tournButtonMain" :style="{backgroundColor: i.bkcolor, color: i.color}">
                                  {{i.num}}
                                </button>
                            </div>
                            <h1 class="TournName">{{i.name}}</h1>
                            <!-- <h1 class="TournCourseName">{{course_name}}</h1> -->
                            <template v-if="bkImage == null">
                              <b-link :to="'/schedule/' + '?tour=' + i.tour" class="allNewsLink">
                                <button class="Allbuttons" :style="{backgroundColor: i.bkcolor, color: i.color}">
                                See Full Schedule
                                </button>
                              </b-link>
                            </template>
                            <template v-else>
                              <b-link :to="'/tournament/' + i.code + '/' + Year + '?tour=' + i.tour" class="allNewsLink">
                                <button class="Allbuttons" :style="{backgroundColor: i.bkcolor, color: i.color}">
                                See Tournament Feed
                                </button>
                              </b-link>
                            </template>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col>
                        <b-tabs>
                          <template v-if="i.tour == 'cpt'">
                            <HomeTabOne
                              :Year="Year"
                              :courseCode="i.code"
                              :TourName="i.name"
                              :manyRounds="i.manyRounds"
                              :TourLogo="TourLogo"
                              :currentReport="currentReport"
                              :currentTitle='currentTitle'
                              :reportURL="reportURL"
                              :live='live'
                              :config="config"
                              :match='match'
                              :roundsPLayed="roundsPLayed"
                              :courseDates="courseDates"
                              :live_scoring="live_scoring"
                              :mobName="i.name"
                              :tour="'cpt'"
                              :Stableford="Stableford"
                            />
                          </template>
                          <template v-else>
                            <HomeTabOne
                              :Year="Year"
                              :courseCode="i.code"
                              :TourName="i.name"
                              :manyRounds="i.manyRounds"
                              :TourLogo="TourLogo"
                              :currentReport="i.reports"
                              :currentTitle='i.repName'
                              :reportURL="i.repURL"
                              :live='live'
                              :config="config"
                              :match='match'
                              :roundsPLayed="roundsPLayed"
                              :courseDates="courseDates"
                              :live_scoring="live_scoring"
                              :mobName="i.name"
                              :tour="i.tour"
                              :Stableford="Stableford"
                            />
                          </template>

                        </b-tabs>
                      </b-col>
                    </b-row>
                    <b-row class="below1200">
                      <b-col lg="12">
                        <b-row class="SponsorLogoText">
                          <b-col>
                            <h1 class="TournName">{{i.name}}</h1>
                            <!-- <h1 class="TournCourseName">{{course_name}}</h1> -->
                            <template v-if="bkImage == null">
                              <b-link :to="'/schedule/' + '?tour=' + i.tour" class="allNewsLink">
                                <button class="Allbuttons" :style="{backgroundColor: i.bkcolor, color: i.color}">
                                See Full Schedule
                                </button>
                              </b-link>
                            </template>
                            <template v-else>
                              <b-link :to="'/tournament/' + i.code + '/' + Year + '?tour=' + i.tour" class="allNewsLink">
                                <button class="Allbuttons" :style="{backgroundColor: i.bkcolor, color: i.color}">
                                See Tournament Feed
                                </button>
                              </b-link>
                            </template>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col lg="12">
                        <b-tabs>
                          <template v-if="i.tour == 'cpt'">
                            <HomeTabOne
                              :Year="Year"
                              :courseCode="i.code"
                              :TourName="i.name"
                              :manyRounds="i.manyRounds"
                              :TourLogo="TourLogo"
                              :currentReport="currentReport"
                              :currentTitle='currentTitle'
                              :reportURL="reportURL"
                              :live='live'
                              :config="config"
                              :match='match'
                              :roundsPLayed="roundsPLayed"
                              :courseDates="courseDates"
                              :live_scoring="live_scoring"
                              :mobName="i.name"
                              :tour="'cpt'"
                              :home="true"
                              :Stableford="Stableford"
                            />
                          </template>
                          <template v-else>
                            <HomeTabOne
                              :Year="Year"
                              :courseCode="i.code"
                              :TourName="i.name"
                              :manyRounds="i.manyRounds"
                              :TourLogo="TourLogo"
                              :currentReport="i.reports"
                              :currentTitle='i.repName'
                              :reportURL="i.repURL"
                              :live='live'
                              :config="config"
                              :match='match'
                              :roundsPLayed="roundsPLayed"
                              :courseDates="courseDates"
                              :live_scoring="live_scoring"
                              :mobName="mobName"
                              :tour="i.tour"
                              :home="true"
                              :Stableford="Stableford"
                            />
                          </template>

                        </b-tabs>
                      </b-col>
                    </b-row>
                  </b-container>
                </div>
              </div>
            </template>
          </vueper-slide>
          <!-- <vueper-slide>
            <template #content>
              <div class="tableHome" v-bind:style="{ 'background-image': 'url(' + backImage+ ')' }">
              </div>
            </template>
          </vueper-slide> -->
        </vueper-slides>
      </div>
      <div class="below990">
        <vueper-slides autoplay :arrows="false" :pauseOnHover="false" :duration="4000" :infinite="true" :touchable="true" :dragging-distance="50">
          <vueper-slide v-for="i in toursAsone" :key="i">
            <template #content>
              <div class="tours">
                <div class="tableHome" v-bind:style="{ 'background-image': 'url(' + tournImage + ')' }">
                  <b-container>
                    <b-row class="above1200">
                      <b-col>
                        <b-row class="SponsorLogoText">
                          <b-col>
                            <div class="classTournBtn">
                                <button class="tournButtonMain" :style="{backgroundColor: i.bkcolor, color: i.color}">
                                  {{i.num}}
                                </button>
                            </div>
                            <h1 class="TournName">{{i.name}}</h1>
                            <!-- <h1 class="TournCourseName">{{course_name}}</h1> -->
                            <template v-if="bkImage == null">
                              <b-link :to="'/schedule/' + '?tour=' + i.tour" class="allNewsLink">
                                <button class="Allbuttons" :style="{backgroundColor: i.bkcolor, color: i.color}">
                                See Full Schedule
                                </button>
                              </b-link>
                            </template>
                            <template v-else>
                              <b-link :to="'/tournament/' + i.code + '/' + Year + '?tour=' + i.tour" class="allNewsLink">
                                <button class="Allbuttons" :style="{backgroundColor: i.bkcolor, color: i.color}">
                                See Tournament Feed
                                </button>
                              </b-link>
                            </template>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col>
                        <b-tabs>
                          <template v-if="i.tour == 'cpt'">
                            <HomeTabOne
                              :Year="Year"
                              :courseCode="i.code"
                              :TourName="i.name"
                              :manyRounds="i.manyRounds"
                              :TourLogo="TourLogo"
                              :currentReport="currentReport"
                              :currentTitle='currentTitle'
                              :reportURL="reportURL"
                              :live='live'
                              :config="config"
                              :match='match'
                              :roundsPLayed="roundsPLayed"
                              :courseDates="courseDates"
                              :live_scoring="live_scoring"
                              :mobName="i.name"
                              :tour="'cpt'"
                              :Stableford="Stableford"
                            />
                          </template>
                          <template v-else>
                            <HomeTabOne
                              :Year="Year"
                              :courseCode="i.code"
                              :TourName="i.name"
                              :TourLogo="TourLogo"
                              :currentReport="i.reports"
                              :currentTitle='i.repName'
                              :reportURL="i.repURL"
                              :manyRounds="i.manyRounds"
                              :live='live'
                              :config="config"
                              :match='match'
                              :roundsPLayed="roundsPLayed"
                              :courseDates="courseDates"
                              :live_scoring="live_scoring"
                              :mobName="i.name"
                              :tour="i.tour"
                              :Stableford="Stableford"
                            />
                          </template>

                        </b-tabs>
                      </b-col>
                    </b-row>
                    <b-row class="below1200">
                      <b-col lg="12">
                        <b-row class="SponsorLogoText">
                          <b-col>
                            <h1 class="TournName">{{i.name}}</h1>
                            <!-- <h1 class="TournCourseName">{{course_name}}</h1> -->
                            <template v-if="bkImage == null">
                              <b-link :to="'/schedule/' + '?tour=' + i.tour" class="allNewsLink">
                                <button class="Allbuttons" :style="{backgroundColor: i.bkcolor, color: i.color}">
                                See Full Schedule
                                </button>
                              </b-link>
                            </template>
                            <template v-else>
                              <b-link :to="'/tournament/' + i.code + '/' + Year + '?tour=' + i.tour" class="allNewsLink">
                                <button class="Allbuttons" :style="{backgroundColor: i.bkcolor, color: i.color}">
                                See Tournament Feed
                                </button>
                              </b-link>
                            </template>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col lg="12">
                        <b-tabs>
                          <template v-if="i.tour == 'cpt'">
                            <HomeTabOne
                              :Year="Year"
                              :courseCode="i.code"
                              :TourName="i.name"
                              :manyRounds="i.manyRounds"
                              :TourLogo="TourLogo"
                              :currentReport="currentReport"
                              :currentTitle='currentTitle'
                              :reportURL="reportURL"
                              :live='live'
                              :config="config"
                              :match='match'
                              :roundsPLayed="roundsPLayed"
                              :courseDates="courseDates"
                              :live_scoring="live_scoring"
                              :mobName="i.name"
                              :tour="'cpt'"
                              :home="true"
                              :Stableford="Stableford"
                            />
                          </template>
                          <template v-else>
                            <HomeTabOne
                              :Year="Year"
                              :courseCode="i.code"
                              :TourName="i.name"
                              :TourLogo="TourLogo"
                              :currentReport="i.reports"
                              :currentTitle='i.repName'
                              :manyRounds="i.manyRounds"
                              :reportURL="i.repURL"
                              :live='live'
                              :config="config"
                              :match='match'
                              :roundsPLayed="roundsPLayed"
                              :courseDates="courseDates"
                              :live_scoring="live_scoring"
                              :mobName="i.name"
                              :tour="i.tour"
                              :home="true"
                              :Stableford="Stableford"
                            />
                          </template>

                        </b-tabs>
                      </b-col>
                    </b-row>
                  </b-container>
                </div>
              </div>
            </template>
          </vueper-slide>
          <vueper-slide>
            <template #content>
              <JustMobSlide
                :frontImage="frontImage"
                :backImage="backImage"
              />
            </template>
          </vueper-slide>
        </vueper-slides>
      </div>

    </template>
    <template v-else>
      <JustSlide
        :frontImage="frontImage"
        :backImage="backImage"
       />
    </template>

    <!-- ignore code below if removed it breaks code above-->
    <div id="myCarousel" class="carousel slide" data-ride="carousel" style="display:none">
      <ol class="carousel-indicators">
        <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
        <li data-target="#myCarousel" data-slide-to="1"></li>
      </ol>

      <div class="carousel-inner">
        <div class="item tours">
          <div class="tableHome" v-bind:style="{ 'background-image': 'url(' + tournImage + ')' }">
            <b-container>
              <b-row class="above1200">
                <b-col>
                  <b-row class="SponsorLogoText">
                    <b-col>
                      <div class="classTournBtn">
                          <button class="tournButtonMain">
                            Tier 1
                          </button>
                      </div>
                      <h1 class="TournName">{{TourName}}</h1>
                      <h1 class="TournCourseName">{{course_name}}</h1>
                      <template v-if="bkImage == null">
                        <b-link :to="'/schedule/' " class="allNewsLink">
                          <button class="Allbuttons">
                          See Full Schedule
                          </button>
                        </b-link>
                      </template>
                      <template v-else>
                        <b-link :to="'/tournament/' + courseCode + '/' + Year " class="allNewsLink">
                          <button class="Allbuttons">
                          See Tournament Feed
                          </button>
                        </b-link>
                      </template>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>

                </b-col>
              </b-row>
              <b-row class="below1200">
                <b-col lg="12">
                  <b-row class="SponsorLogoText">
                    <b-col>
                      <div class="dates">
                        <h2 class="TournDates">{{tournDates}}</h2>
                      </div>
                      <h1 class="TournName">{{TourName}}</h1>
                      <h1 class="TournCourseName">{{course_name}}</h1>
                      <template v-if="bkImage == null">
                        <b-link :to="'/schedule/'" class="allNewsLink">
                          <button class="Allbuttons">
                          See Full Schedule
                          </button>
                        </b-link>
                      </template>
                      <template v-else>
                        <b-link :to="'/tournament/' + courseCode + '/' + Year" class="allNewsLink">
                          <button class="Allbuttons">
                          See Tournament Feed
                          </button>
                        </b-link>
                      </template>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col lg="12">
                </b-col>
              </b-row>
            </b-container>
            <b-row class="imagefilesPos">
              <b-col class="imageSize" lg="" sm="6" v-for="(image, index) in imagefiles" :key="'twentytwodex' + index" v-show="image.ad_lcc == 'N' && image.ad_file != ''" >
                <b-link :href="image.ad_link" :title="image.ad_desc" target="_blank">
                  <div class="imagefileImage" v-bind:style="{ 'background-image': 'url(' + image.ad_file + ')' }"></div>
                </b-link>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template> 

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import HomeTabOne from "@/components/homeTabOne.vue";
import JustSlide from "@/components/justSlides.vue";
import JustMobSlide from "@/components/justMobSlides.vue";
import apiCall from "@/services/api.js";
import axios from 'axios';
export default {
  name: "tableHome",
  props: ["Year", "tournDates",  "imageCode",  "courseCode", "TourName", "mobName", "TourLogo", "bkImage", "currentReport", "reportURL", 'live', 'config','match', 'currentTitle','roundsPLayed', 'imagefiles', 'course_name', 'courseDates', 'live_scoring','cptAll', 'cp2All'
          ,'cp3All'
          ,'pamAll'
          ,'qscAll'
          ,'porAll',
          "showcptreports",
          "showcp2reports",
          "showcp3reports",
          "showpamreports",
          "showqscreports",
          "showporreports",
          "Stableford",
          "qscshowTourn",
          "pamshowTourn",
          "cp2showTourn",
          "cp3showTourn",
          "porshowTourn",
          "cptshowTourn"
        ],
  components: {
    HomeTabOne,
    VueperSlides, VueperSlide,
    JustSlide,
    JustMobSlide
  },
  data() {
    return {
      tournImage: '',
      acf:[],
      allUp:[],
      toursAll: JSON.parse(localStorage.getItem("all")),
      frontImage:[],
      backImage:'',
      slideshow: []
      // allNewSlides: []
    };
  },
  methods: {   
    getHomeImage: function() {
      axios //add API Call
          .get(
              'https://wp-cpt.ocs-software.com/' + "/wp-json/wp/v2/pages/8"
          ) // Page number changed on each page based on JSON page id you are calling
          .then((response) => (
              this.acf = response.data,
              this.frontImage = response.data.acf.front_image,
              this.backImage = response.data.acf.backup_front_image,
              console.log("this.backImage"),
              console.log(this.backImage)
          )); //API data wanted pulled out
    },
    TournamentBKimage: function() {
      this.tournImage = ''
      if (this.bkImage == '') {
        this.tournImage = 'https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/tourninfo.png'
      } else {
        this.tournImage = 'https://tms-images.ams3.cdn.digitaloceanspaces.com/cpt/courses/' + this.Year + '/' + this.imageCode + '/' + this.bkImage
        // https://tms-images.ams3.cdn.digitaloceanspaces.com/cpt/courses/2025/LGW/File_1.jpeg
      }
    },
    scroll() {
      var score = document.getElementById("download");
      score.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    oneSlide() {
      const json = "wp/v2/slideshow?randomadd=" +
              new Date().getTime();
      apiCall
        .wpInfo(json)
        .then(({ data }) => {
          this.slideshow = data[0].acf.slideshow;
          console.log( "this.slideshow")
          console.log( this.slideshow)
        })
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },
  },
  computed: {
    shuffledItems() {
      // Slice to create a copy, then sort randomly
      return this.slideshow.slice(0).sort(() => 0.5 - Math.random());
    },
    toursAsone : function() {
      const children = [
        ...this.cptAll,
        ...this.cp2All,
        ...this.cp3All,
        ...this.pamAll,
        ...this.porAll,
        ...this.qscAll
      ].filter(({ daysAway }) => {
        const d = +daysAway;
        return d > -5 && d < 5;
      });
      let allNewSlides = [];
      children.forEach((value) => {
        allNewSlides.push(value);    
      });
      return allNewSlides
    },
    // allTogetherData() {
    //   let allNewSlides = [];
    //   this.toursAsone.forEach((value) => {
    //     console.log("value")
    //     console.log(value)
    //     if (value.reports != '' && value.reports != 'undefined') {
    //       allNewSlides.push(value);    
    //     } else {  
    //       console.log('error'); 
    //     }
    //   });
    //   return allNewSlides
    // },
  },
  mounted() {
    this.getHomeImage();
    this.TournamentBKimage();
    this.oneSlide();
    // this.allTogetherData();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media only screen and (max-width: 1366px) {
    h1.heading {
        text-transform: uppercase;
        font-size: 50px;
        /* font-weight: bold; */
        font-family: "brown-pro-condensed", sans-serif;
        font-weight: 800;
        font-style: normal;
    }
    p.line1 {
        /* text-transform: uppercase; */
        font-size: 20px;
    }
    p.line2 {
        /* text-transform: uppercase; */
        font-size: 15px;
    }
    p.line3 {
        /* text-transform: uppercase; */
        font-size: 10px;
    }
}
@media only screen and (min-width: 991px) {
    ::v-deep .below990 {
        display: none;
    }
}
@media only screen and (max-width: 990px) {
    ::v-deep .above990 {
        display: none;
    }
}
img.active.tableHome.firstClass {
  padding-bottom: 0%!important;
}
h1.heading {
    /* text-transform: uppercase; */
    font-size: 70px;
    /* font-weight: bold; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
}
p.line1 {
    /* text-transform: uppercase; */
    font-size: 40px;
}
p.line2 {
    /* text-transform: uppercase; */
    font-size: 20px;
}
p.line3 {
    /* text-transform: uppercase; */
    font-size: 10px;
}
.innerDiv {
    position: absolute;
    top: 30%;
    color: #fff;
    z-index: 999;
    /* height: 200px; */
    width: 100%;
    background-color: rgba(8, 28, 63, 0.5);
    text-align: center;
    padding-top: 30px;
    padding-bottom: 30px;
}
::v-deep .vueperslides__parallax-wrapper {
  /* height: 970px; */
  height: 700px;
}
.tours:before {
  content: "";
  position: absolute;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  height: 100%;
}
.classTournBtn {
  margin-bottom: 30px;
}
.tournButtonMain {
  background-color: #00FFFE;
  color: #081C3F;
  border: none;
  width: 169px;
  height: 51px;
  /* font-weight: bold; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  font-size: 20px;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  border-radius: 26px;
}
.carousel-indicators .active {
  width: 12px;
  height: 12px;
  background-color: #00FFFE;
  border-radius: 30px;
  border: none;
}
.carousel-indicators li {
  border-radius: 30px;
  border: none;
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 12px;
  height: 12px;
  margin-right: 5px;
  margin-left: 14px;
  text-indent: -997px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 0px solid transparent;
  border-bottom: 0px solid transparent;
  opacity: .5;
  transition: opacity 0.6s ease;
  margin-top: 0px;
}
.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 0;
  margin-left: 0;
  list-style: none;
  width: 100%;
}
.tableHome.noImage {
  background-image: url('https://ams3.digitaloceanspaces.com/ocs-sport/alpstourgolf/2018/02/course.png')!important;
  background-repeat: no-repeat;
  background-size: cover;
}
.row.imagefilesPos {
  position: absolute;
  width: 100%;
  /* bot: 10em; */
  margin-top: 2em;
}
.imagefileImage {
  height: 80px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 200px;
  margin: auto;
}
.outerBorderImage {
  border-radius: 50%;
  height: 258px;
  width: 258px;
  /* border: 19px solid #ff0000; */
  /* opacity: 0.9; */
  margin-top: -32px;
  background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/White_Circle.png);
  background-repeat: no-repeat;
  background-size: contain;
}
.outerSponImage {
  /* background-color: #fff; */
  border-radius: 50%;
  /* height: 230px;
  width: 230px; */
  height: 232px;
  width: 232px;
}
img.sponsorImage {
  /* width: 120px;
  max-width: 120px;
  position: relative;
  top: 50px;
  left: 29%;
  overflow: hidden; */
    width: 166px;
    max-width: 299px;
    position: relative;
    /* top: 70px; */
    top: 46px;
    /* top: 100px; */
    left: 20%;
    overflow: hidden;
}
img.sponsorImageNull {
  width: 227px;
  max-width: 312px;
  position: relative;
  /* top: 70px; */
  top: 5em;
  /* top: 100px; */
  left: 7%;
  overflow: hidden;
  }
.SponsorLogoText {
  /* margin-top: 17em; */
  margin-top: 10em;
}
.Allbuttons {
  /* float: right; */
  width: 247px;
  height: 52px;
  /* background: #081C3F; */
  font-size: 20px;
  color: #081C3F;
  /* font-weight: bold; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border: 0px solid #081C3F;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  border-radius: 26px;
}
.Allbuttons:hover {
  /* float: right; */
  width: 247px;
  height: 52px;
  font-size: 20px;
  background: #081C3F!important;
  color: #fff!important;
  /* font-weight: bold; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  border: 1px solid #081C3F;
  transform: translateY(-10px);
  border-radius: 26px;
}
.TournDates {
  font-size: 20px;
  color: #fff;
  font-weight: bold;
  text-align: center;
  padding-top: 3px;
  padding-bottom: 3px;
}
.dates {
  background-color: #081C3F;
  border-radius: 30px;
  width: 200px;
}
.TournName {
  font-size: 60px;
  color: #fff;
  /* font-weight: bold; */
  font-family: "brown-pro-condensed", sans-serif;
  font-weight: 800;
  font-style: normal;
  margin-top: 55px;
  margin-bottom: 50px;
}
.TournCourseName {
  font-size: 40px;
  color: #fff;
  font-weight: bold;
  padding-bottom: 20px;
}
.tabs {
  /* width: auto; */
  /* width: 450px; */
  width: 536px;
  border-radius: 30px;
  /* margin-top: 5em; */
  /* margin-top: 2em; */
  /* margin-top: 11em; */
  margin-top: 5em;
  float: right;
  position: relative;
}

::v-deep .nav-link.active {
  color: white !important;
  background-color: #081C3F !important;
  width: 100%;
  border-color: #081C3F !important;
  height: 100%;
}

::v-deep .nav-link {
  color: black !important;
  width: 100%;
  font-size: 18pt;
  font-weight: 500;
}

::v-deep li.nav-item {
  width: 100%;
  text-align: center;
}
.tableHome {
  padding-bottom: 2%;
  background-repeat: no-repeat;
  /* height: 700px; */
  /* height: 970px; */
  height: 700px;
  background-size: cover;
  /* margin-bottom: 4em; */
  background-position: center;
}
.mt {
  margin-top: 0 !important;
}
::v-deep .nav-tabs{
  border-bottom: 0e6;
}
::v-deep .nav-tabs .nav-link {
    margin-bottom: -1px;
    border: 1px solid transparent;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
}
@media only screen and (min-width: 2000px) {
  .tableHome {
    height: 1300px;
  }
}
@media only screen and (min-width: 1201px) {
  .below1200 {
    display: none;
  }
}
@media only screen and (min-width: 991px) {
  .below1200 {
    display: none;
  }
}
@media only screen and (max-width: 990px) {
  .above1200 {
    display: none;
  }
  ::v-deep .vueperslides__parallax-wrapper {
    /* height: 970px; */
    height: 750px;
  }
}
@media only screen and (max-width: 1200px) {
  .tabs {
    width: 100%;
    border-radius: 30px;
    /* margin-top: 5em; */
    margin-top: 2em;
    float: none;
    position: relative;
  }
  .SponsorLogoText {
    /* margin-top: 10em; */
    margin-top: 2em;
  }
}
@media only screen and (max-width: 1199px) {
  .tableHome:before {
    content: "";
    position: absolute;
    overflow: hidden;
    width: 100%;
    max-height: 700px;
    height: 38em;
    top: 7.5em;
    /* background-color: rgba(0, 0, 0, 0.5); */
  }
}
/* @media only screen and (max-width: 768px) {
  .tableHome:before {
    content: "";
    position: absolute;
    overflow: hidden;
    width: 100%;
    max-height: 970px;
    height: 970px;
    top: 76px;
    background-color: rgba(0, 0, 0, 0.5);
  }
} */
@media only screen and (max-width: 990px) {
  ::v-deep .vueperslides__bullets {
    display: none;
  }
  .Allbuttons {
    /* float: right; */
    width: 247px;
    height: 52px;
    /* background: #081C3F; */
    font-size: 14px;
    color: #081C3F;
    /* font-weight: bold; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border: 0px solid #081C3F;
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);
    border-radius: 26px;
  }
  .Allbuttons:hover {
    /* float: right; */
    width: 247px;
    height: 52px;
    font-size: 14px;
    background: #081C3F!important;
    color: #fff!important;
    /* font-weight: bold; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    border: 1px solid #081C3F;
    transform: translateY(-10px);
    border-radius: 26px;
  }
  .TournName {
    font-size: 60px;
    color: #fff;
    /* font-weight: bold; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    margin-top: 0px;
    margin-bottom: 25px;
  }
  .dates {
    margin: auto;
  }
  .row.imagefilesPos {
    display: none;
  }
  .tableHome {
    padding-bottom: 2%;
    background-repeat: no-repeat;
    /* height: 920px; */
    /* height: 970px; */
    /* height: 700px; */
    height: 750px;
    background-size: cover;
    margin-bottom: 0em;
    background-position: center;
  }
  .tabs {
    width: auto;
    border-radius: 30px;
    margin-top: 3em;
    /* margin-top: 10em; */
    float: none;
    position: relative;
  }
  .outerBorderImage {
    border-radius: 50%;
    height: 190px;
    width: 190px;
    /* border: 19px solid #ff0000; */
    /* opacity: 0.9; */
    margin-top: -88px;
    background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/White_Circle.png);
    background-repeat: no-repeat;
    background-size: contain;
    margin-left: 100px;
  }
  img.sponsorImage {
      width: 120px;
      /* max-width: 120px; */
      position: relative;
      top: 39px;
      left: -9%;
  }
  .TournDates {
    font-size: 18px;
    color: #fff;
    font-weight: bold;
    /* padding-bottom: 20px; */
  }
  .TournName {
    font-size: 30px;
    color: #fff;
    /* font-weight: bold; */
    font-family: "brown-pro-condensed", sans-serif;
    font-weight: 800;
    font-style: normal;
    /* padding-bottom: 20px; */
    /* padding-top: 20px; */
  }
  .TournCourseName {
    font-size: 18px;
    color: #fff;
    font-weight: bold;
    padding-top: 00px;
    padding-bottom: 0px;
  }
  .SponsorLogoText {
    margin-top: 2em;
    text-align: left;
  }
}
@media only screen and (max-width: 510px) {
  ::v-deep .vueperslides__parallax-wrapper {
    /* height: 726px; */
  }
}
@media only screen and (max-width: 480px) {
 ::v-deep .nav-link{
    font-size: 1rem;
  }
}
@media only screen and (max-width: 375px) {
  .outerBorderImage {
    border-radius: 50%;
    height: 190px;
    width: 190px;
    /* border: 19px solid #ff0000; */
    /* opacity: 0.9; */
    margin-top: -88px;
    background-image: url(https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/White_Circle.png);
    background-repeat: no-repeat;
    background-size: contain;
    margin-left: 75px;
  }
  ::v-deep .vueperslides__parallax-wrapper {
    height: 750px;
  }
  .tableHome {
      padding-bottom: 2%;
      background-repeat: no-repeat;
      /* height: 920px; */
      /* height: 970px; */
      height: 750px;
      background-size: cover;
      margin-bottom: 0em;
      background-position: center;
  }
}
</style>
